import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { routes } from './app.routes';
import { HttpClient, provideHttpClient, withInterceptors } from '@angular/common/http';
import { initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { getFirestore, provideFirestore } from '@angular/fire/firestore';
import { getAuth, provideAuth } from '@angular/fire/auth';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateUniversalLoader } from './translate-universal-loader';
import { provideMatomo, withRouteData, withRouter } from 'ngx-matomo-client';
import { tokenInterceptorFn } from './core/http/token.interceptor';
import { provideAnimations } from '@angular/platform-browser/animations';

import { environment } from '../../../commondata/environments/environment';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';

export const appConfig: ApplicationConfig = {
  providers: [
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: { appearance: 'outline', subscriptSizing: 'dynamic' },
    },
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withComponentInputBinding()),
    provideAnimations(),
    provideHttpClient(withInterceptors([tokenInterceptorFn])),
    provideFirebaseApp(() => initializeApp(environment.configFirebase)),
    provideFirestore(() => getFirestore()),
    provideAuth(() => getAuth()),
    [{ provide: MAT_DATE_LOCALE, useValue: "it-IT" }],
    provideMatomo(
      { trackerUrl: "https://matomo.anastasis.it/", siteId: (environment.production ? "4" : "7") },
      withRouter(),
      withRouteData(),
    ),

    importProvidersFrom([
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useClass: TranslateUniversalLoader,
          deps: [HttpClient],
        },
      }),
    ]),
  ],
};
